import React from "react";
import commercialImage from "../img/DC-Commercial.png";

const Commercial = () => (
  <section id="commercial" className="w-full min-w-full h-full flex-shrink-0 snap-start flex items-center justify-center bg-gray-100 p-4 sm:p-6 md:p-8 overflow-y-auto">
    <div className="text-center max-w-4xl w-full bg-white rounded-lg shadow-xl p-4 sm:p-6 md:p-8 my-4 sm:my-0">
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">Commercial Real Estate</h1>
      <h2 className="text-xl sm:text-2xl md:text-3xl mb-6 sm:mb-8">St. Louis and Surrounding Missouri Counties</h2>
      <p className="text-lg sm:text-xl md:text-2xl mb-6 sm:mb-8">Comprehensive Commercial Real Estate Services</p>
      <div className="flex flex-col md:flex-row items-start justify-between gap-6">
        <ul className="text-base sm:text-lg md:text-xl list-disc list-inside text-left md:w-1/2 order-2 md:order-1">
          <li>Office space leasing and sales</li>
          <li>Retail property transactions</li>
          <li>Industrial real estate solutions</li>
          <li>Land acquisition and development</li>
          <li>Market analysis and valuation</li>
        </ul>
        <img src={commercialImage} alt="Commercial Real Estate" className="w-full md:w-1/2 h-auto rounded-lg shadow-md order-1 md:order-2" />
      </div>
      <p className="text-base sm:text-lg md:text-xl mt-6 sm:mt-8">At Driscoll Co, we leverage our extensive experience and market knowledge to provide tailored commercial real estate services.</p>
    </div>
  </section>
);

export default Commercial;
